import {createReducer} from '@reduxjs/toolkit'
import {AnyAction} from 'redux'
import {GET_CONNECTED_GROUP_OLD, GET_GROUP_ACTIVITY_OLD, getConnectedGroup, getGroupActivity} from '../actions/groups'
import {GroupsState} from '../types/state'

const defaultState: GroupsState = {
  group: undefined,
  updates: undefined,
}

export const groups = createReducer(defaultState, builder => {
  builder
    .addCase(GET_CONNECTED_GROUP_OLD.SUCCESS, (state, action: AnyAction) => {
      state.group = action.payload?.group
    })
    .addCase(getConnectedGroup.fulfilled, (state, action) => {
      state.group = action.payload?.group
    })
    .addCase(GET_GROUP_ACTIVITY_OLD.SUCCESS, (state, action: AnyAction) => {
      state.updates = action.payload.totalPosts
    })
    .addCase(getGroupActivity.fulfilled, (state, action) => {
      state.updates = action.payload.totalPosts
    })
})
